export const dataOrderSummary = [
  {
    id: 1,
    ticket: "Vip A Ticket",
    place: "SL",
    quantity: 3,
    price: "$600.00",
  },
  {
    id: 2,
    ticket: "Vip B Ticket",
    place: "SM",
    quantity: 1,
    price: "$100.00",
  },
  {
    id: 3,
    ticket: "Vip C Ticket",
    place: "SU",
    quantity: 1,
    price: "$50.00",
  },
];

export const dataPaymentMethods = [
  {
    id: 1,
    title: "Visa",
    source: "/images/visa_card.png",
    alt: "VISA",
  },
  {
    id: 2,
    title: "Mada card",
    source: "/images/mada_card.png",
    alt: "MADA",
  },
  // {
  //   id: 3,
  //   title: "STCPAY",
  //   source: "/images/stc_pay.png",
  //   alt: "STCPAY",
  // },
  {
    id: 4,
    title: "MASTERCARD",
    source: "/images/master_card.png",
    alt: "MASTERCARD",
  },
];
